/**
 * Converts object to array of objects with their own keys and values
 */
export default function convertObjectToArrayOfObjects(object: object, id: string = "id", value: string = "name"): any[] {
    return Object.entries(object).map((member) => ({
        [id]: member[0],
        [value]: member[1],
    }))
}